<template>
  <v-card
   ripple
   height="100%"
   class="flexcard"
   :dark="selected"
   @click.native.prevent="selectMedia(media)">
    <v-responsive>
      <cloudinary-image
        v-if="media.resource_type === 'image' || media.resource_type === 'video'"
        :id="media.public_id"
        :type="media.resource_type"
        :version="media.version"
        :transformation="media.format === 'pdf' ? 'w_600,h_300,c_lpad,f_jpg,b_grey' :'w_600,h_300,c_fill,q_auto,f_jpg,g_faces:center'"
      />
      <v-img
        :aspect-ratio="2"
        v-if="media.resource_type === 'raw'"
        class="accent">
        <v-layout
          fill-height
          align-center
          justify-center>
          <v-flex class="text-xs-center">
            <v-icon large>attach_file</v-icon>
            <div class="font-weight-black text--white">{{ media.format }}</div>
          </v-flex>
        </v-layout>
      </v-img>
    </v-responsive>
    <v-tooltip top>
      <v-card-title primary-title class="grow pt-3" slot="activator">
        <span class="body-2 tronchetto">
          <media-icon :mediaFormat="media.format" :mediaType="media.resource_type" /> {{ media.format }} - {{ media.title }}
        </span>
      </v-card-title>
      {{ media.title }}
    </v-tooltip>
  </v-card>
</template>

<script>
import cloudinaryImage from '@/components/common/CloudinaryImage'
import mediaIcon from '@/components/media/MediaIcon'

export default {
  props: {
    media: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean
    }
  },
  data: () => ({
    isSelected: false
  }),
  components: {
    cloudinaryImage,
    mediaIcon
  },
  methods: {
    selectMedia (media) {
      this.$emit('media:selected', media)
    }
  }
}
</script>

<style scoped>
  .flexcard {
    display: flex;
    flex-direction: column;
    position: relative;
  }
  .flexcard:hover {
    cursor: pointer;
  }
  .flexcard img {
    max-width: 100%;
  }
  .flexcard-videoIcon {
    position: absolute;
    left: 10px;
    top: 10px;
  }
  .tronchetto {
    white-space: nowrap;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>
